/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-08 15:37:27
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-09-14 13:53:28
 * @FilePath     : /marketing-introduce-ssr/components/Activity/Swiper/index.tsx
 * @Description  : 未添加文件描述
 */

import cx from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import { reportError } from '@/utils';

import styles from './index.module.scss';
// import { isBrowser } from '@/common/const'

interface SwiperProps {
  style?: React.CSSProperties;
  children?: React.ReactChild | React.ReactChild[];
  className?: string;
  multi: boolean;
}

function animationStep(
  el: HTMLDivElement,
  { itemHeight, speed }: { itemHeight: number; speed: number },
  fn: (type: 'next' | 'curr') => void
) {
  let start = 0;
  return (timestamp: number) => {
    try {
      if (el) {
        if (start === 0) start = timestamp;
        const elapsed = timestamp - start;

        el.style.transform = `translate3d(0px, ${Math.max(-speed * elapsed, -itemHeight)}px, 0px)`;

        if (elapsed < 500) {
          fn('curr');
        } else {
          fn('next');
        }
      }
    } catch (e) {
      reportError(e);
    }
  };
}

interface ItemSwitchType {
  time?: number;
  speed?: number;
}

// 滚动
export const itemSwitch = (
  el: HTMLDivElement | null,
  ops: ItemSwitchType,
  func?: (children: HTMLCollection, ele?: Element) => void
): NodeJS.Timeout | undefined => {
  if (el && window) {
    const { children } = el;

    const itemHeight = children[0]?.clientHeight || 0;
    const marginBottom = parseFloat(
      (window.getComputedStyle(el.children[0], null).marginBottom || '0px').replace('px', '')
    );

    // console.log(marginBottom);
    let next = true;
    if (typeof func === 'function') {
      func(children, children[0]);
    }

    return setInterval(() => {
      if (!next) {
        return null;
      }
      const firstEle = children[0];
      el.appendChild(firstEle);

      if (typeof func === 'function') {
        func(children, firstEle);
      }

      const fn = animationStep(
        el,
        {
          itemHeight: itemHeight + marginBottom,
          speed: ops.speed || 0.4
        },
        (type) => {
          if (type === 'curr') {
            next = false;
            window.requestAnimationFrame(fn);
          } else {
            next = true;
          }
        }
      );
      window.requestAnimationFrame(fn);
    }, ops.time || 3000);
  }
};

const Swiper = React.memo(({ style, children, className, multi }: SwiperProps): JSX.Element => {
  const [showChild, setShowChild] = useState(false);
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setShowChild(true);
    if (showChild) {
      itemSwitch(elRef.current, {
        speed: 0.4
      });
    }
  }, [showChild]);

  return (
    <div
      style={style}
      className={cx(styles['cp-swiper'], multi ? styles.multi : styles.less, className)}>
      {multi ? (
        <div ref={elRef} className={styles.multi}>
          {showChild && children}
        </div>
      ) : (
        <div ref={elRef} className={styles.list}>
          {showChild && children}
        </div>
      )}
    </div>
  );
});

export { Swiper };
